import { render, staticRenderFns } from "./ValidationStatusMobile.vue?vue&type=template&id=c89fb678&"
import script from "./ValidationStatusMobile.vue?vue&type=script&lang=js&"
export * from "./ValidationStatusMobile.vue?vue&type=script&lang=js&"
import style0 from "./ValidationStatusMobile.vue?vue&type=style&index=0&id=c89fb678&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports